export default __webpack_public_path__ + "static/media/Logo Santander.5051d2d9.svg";